import { connect } from 'react-redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import { bindActionCreators } from 'redux'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as OrgActions from 'app/modules/org/actions'
import * as OrgSelectors from 'app/modules/org/selectors'
import { PlaybookStatus } from 'app/modules/playbook/constants'

import ConditionModal from './component'

const mapStateToProps = state => ({
  isCardinalityLoading: PlaybookSelectors.cardinalityLoading(state),
  targetingCardinality: PlaybookSelectors.targetingCardinality(state),
  isOneTimeEmailPlaybook: PlaybookSelectors.getIsOneTimeEmailPlaybook(state),
  hasLimitedContactsMktEmail: OrgSelectors.hasLimitedContactsMktEmail(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setDraftStatus: PlaybookActions.setDraftStatus,
    hideSendEmailConfirmModal: PlaybookActions.hideSendEmailConfirmModal,
    hasLimitedContactsMktEmail: OrgActions.hasLimitedContactsMktEmail
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      const {
        actions: { hasLimitedContactsMktEmail }
      } = this.props

      hasLimitedContactsMktEmail()
    }
  }),
  withHandlers({
    onCloseClick: ({ actions: { hideSendEmailConfirmModal }}) => () => {
      hideSendEmailConfirmModal()
    },
    onConfirmClick: ({ isOneTimeEmailPlaybook, actions: { hideSendEmailConfirmModal, setDraftStatus }}) => () => {
      setDraftStatus({ status: isOneTimeEmailPlaybook ? PlaybookStatus.SENT : PlaybookStatus.ENABLED })
      hideSendEmailConfirmModal()
    },
  }),
)(ConditionModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SendEmailConfirmModal/index.js